import { render, staticRenderFns } from "./indexmaster.vue?vue&type=template&id=455ed2f4&"
import script from "./indexmaster.vue?vue&type=script&lang=js&"
export * from "./indexmaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports